(ns practitest.frontend.components.view-editor.subs
  (:require
    [clojure.string :as str]
    [practitest.frontend.components.view-editor.basic-builder :as bb]
    [re-frame.core :as re-frame]))

;; TODO: re-frame 1.3.0+ adds :-> shorthand

;; ---- subs ----

(re-frame/reg-sub ::state (fn [db _] (:view-editor db)))
(re-frame/reg-sub ::open? :<- [::state] (fn [s _] (boolean (:open? s))))
(re-frame/reg-sub ::mode :<- [::state] (fn [s _] (:mode s)))
(re-frame/reg-sub ::entity-type :<- [::state] (fn [s _] (:entity-type s)))
(re-frame/reg-sub ::display-mode :<- [::state] (fn [s [_ section]] (get-in s [:display-modes section] :optimized)))
(re-frame/reg-sub ::filter-render-mode :<- [::state] (fn [s _] (or (:filter-render-mode s) :advanced)))
(re-frame/reg-sub ::loading? :<- [::state] (fn [s _] (boolean (:loading? s))))
(re-frame/reg-sub ::saving? :<- [::state] (fn [s _] (boolean (:saving? s))))
(re-frame/reg-sub ::recomputing? :<- [::state] (fn [s _] (boolean (:recomputing? s))))
(re-frame/reg-sub ::error :<- [::state] (fn [s _] (:error s)))
(re-frame/reg-sub ::ptql-error :<- [::state] (fn [s _] (:ptql-error s)))
(re-frame/reg-sub ::auto-filter-options :<- [::state] (fn [s _] (:auto-filter-options s)))
(re-frame/reg-sub ::auto-filter-max-levels :<- [::state] (fn [s _] (:auto-filter-max-levels s)))
(re-frame/reg-sub ::auto-filter-limit-reached? :<- [::state] (fn [s _] (boolean (:auto-filter-limit-reached? s))))
(re-frame/reg-sub ::available-fields :<- [::state] (fn [s _] (:available-fields s)))
(re-frame/reg-sub ::form :<- [::state] (fn [s _] (:form s)))
(re-frame/reg-sub ::basic-builder-ast :<- [::form] (fn [f _] (:basic-builder-ast f)))

(re-frame/reg-sub
  ::save-disabled-reason
  :<- [::form]
  :<- [::filter-render-mode]
  :<- [::ptql-error]
  (fn [[form render-mode ptql-error] _]
    (cond
      (str/blank? (:name form))
      :empty-name

      (and (= :auto-filter (:mode form))
           (empty? (remove str/blank? (:auto-filter form))))
      :no-auto-filter

      (and (= :ptql (:mode form))
           (= :basic render-mode)
           (bb/has-incomplete-clauses? (:basic-builder-ast form)))
      :incomplete

      (and (= :ptql (:mode form))
           (= :advanced render-mode)
           (some? ptql-error))
      :invalid-ptql)))
